(function () {
  'use strict';

  if (window.CrestSharedSaved) return;

  const key =
    'crest:routine:saved:' +
    (window.Shopify?.shop || location.host) +
    ':v1';

  const states = new WeakMap();

  const simple = item =>
    !item.selling_plan_allocation &&
    !Object.keys(item.properties || {}).length &&
    !item.parent_relationship?.parent &&
    !item.item_components?.length;

  const escape = value =>
    String(value ?? '').replace(
      /[&<>"']/g,
      character => ({
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
      })[character]
    );

  function safeURL(value, image = false) {
    try {
      const url = new URL(value, location.origin);

      if (
        ['https:', 'http:'].includes(url.protocol) &&
        (
          url.origin === location.origin ||
          (image && url.hostname === 'cdn.shopify.com')
        )
      ) {
        return url.href;
      }
    } catch (_) {}

    return '';
  }

  function readSaved() {
    const data = JSON.parse(localStorage.getItem(key) || '[]');

    if (!Array.isArray(data)) return [];

    return data
      .filter(item =>
        item &&
        typeof item.uid === 'string' &&
        /^\d+$/.test(String(item.variant)) &&
        Number.isSafeInteger(item.quantity) &&
        item.quantity > 0
      )
      .slice(0, 20);
  }

  function writeSaved(list) {
    localStorage.setItem(key, JSON.stringify(list));
  }

  function upsert(record, replace) {
    const list = readSaved();
    const index = list.findIndex(item => item.uid === record.uid);

    if (index >= 0 && !replace) return false;

    if (index < 0 && list.length >= 20) {
      throw Error(
        'Hai già 20 prodotti salvati. Rimuovine uno prima di continuare.'
      );
    }

    if (index >= 0) {
      list[index] = record;
    } else {
      list.push(record);
    }

    writeSaved(list);
    return true;
  }

  function drop(uid) {
    writeSaved(readSaved().filter(item => item.uid !== uid));
  }

function sync() {
  document.querySelector('crest-routine-page')?.renderSaved?.();

  document
    .querySelectorAll('crest-shared-saved')
    .forEach(node => node.draw?.());

  document.dispatchEvent(new CustomEvent('crest-saved:updated'));
}

  function notice(scope, text) {
    if (scope.matches('crest-routine-page')) {
      scope.notice(text);
      return;
    }

    if (typeof scope.showUpdateNotice === 'function') {
      scope.showUpdateNotice(text);
      return;
    }

    const inner = scope.querySelector('.drawer__inner');
    if (!inner) return;

    let node = inner.querySelector('.crest-drawer__notice');

    if (!node) {
      node = document.createElement('p');
      node.className = 'crest-drawer__notice';
      node.setAttribute('role', 'status');
      node.setAttribute('aria-live', 'polite');

      const header = inner.querySelector('.drawer__header');

      if (header) {
        header.after(node);
      } else {
        inner.prepend(node);
      }
    }

    node.textContent = text;
  }

  async function cart() {
    const response = await fetch(
      (window.Shopify?.routes?.root || '/') + 'cart.js',
      {
        credentials: 'same-origin',
        cache: 'no-store'
      }
    );

    if (!response.ok) {
      throw Error('Impossibile verificare il carrello. Riprova.');
    }

    const result = await response.json();

    if (
      !Array.isArray(result.items) ||
      !Number.isFinite(result.item_count)
    ) {
      throw Error('Risposta del carrello incompleta.');
    }

    return result;
  }

  async function post(endpoint, body) {
    CartItems.invalidateCartView();

    const response = await fetch(
      (window.Shopify?.routes?.root || '/') + endpoint,
      {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(body)
      }
    );

    const result = await response.json();

    if (!response.ok || result.status || result.errors) {
      throw Error(
        typeof result.description === 'string'
          ? result.description
          : 'Richiesta non disponibile.'
      );
    }

    return result;
  }

  function drawerRun(drawer, task) {
    if (
      states.get(drawer) ||
      drawer.dataset.crestToolsBusy === 'true' ||
      drawer.dataset.crestUpsellBusy === 'true'
    ) {
      return Promise.resolve();
    }

    states.set(drawer, true);

    drawer.querySelectorAll('crest-shared-saved').forEach(node => {
      node.inert = true;
    });

    drawer.dataset.crestToolsBusy = 'true';
    drawer.setRefreshing(false);

    const previous = CartItems.mutationQueue || Promise.resolve();
    const refreshing = drawer.refreshPromise;

    const operation = Promise
      .allSettled([previous, refreshing])
      .then(async () => {
        let text = '';
        let current = null;

        try {
          text = await task();
        } catch (error) {
          text =
            error.message +
            ' Verifica il carrello prima di riprovare.';
        }

        try {
          current = await cart();
          CartItems.invalidateCartView();

          const items = drawer.querySelector('cart-drawer-items');

          if (await items.onCartUpdate() !== true) {
            throw Error('view');
          }
        } catch (_) {
          text +=
            ' Riapri il carrello per verificare il riepilogo aggiornato.';
        }

        return { text, current };
      });

    CartItems.mutationQueue = operation.catch(() => {});

    return operation
      .then(({ text, current }) => {
        if (current) {
          try {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'cart-items',
              sourceElement: drawer.querySelector('cart-drawer-items'),
              cartData: current
            });

            document.dispatchEvent(
              new CustomEvent('crest-pairings:cart-changed', {
                detail: { cart: current }
              })
            );
          } catch (error) {
            console.warn('CREST aggiornamento', error);
          }
        }

        notice(drawer, text);
      })
      .finally(() => {
        states.delete(drawer);

        drawer.querySelectorAll('crest-shared-saved').forEach(node => {
          node.inert = false;
        });

        delete drawer.dataset.crestToolsBusy;

        drawer.setRefreshing(
          drawer.dataset.crestCartRefreshing === 'true'
        );

        sync();
        drawer.focusContents?.();
      });
  }

  function lineRecord(item) {
    return {
      uid: String(item.variant_id),
      variant: String(item.variant_id),
      quantity: item.quantity,
      title: item.product_title || item.title,
      format: item.variant_title || '',
      url: safeURL(item.url),
      image: safeURL(item.image || item.featured_image?.url, true)
    };
  }

  function saveLine(button, scope) {
    if (scope.matches('crest-routine-page')) {
      return scope.remove(
        button.dataset.key,
        Number(button.dataset.quantity),
        true
      );
    }

    return drawerRun(scope, async () => {
      const current = await cart();

      const item = current.items.find(
        item => item.key === button.dataset.key
      );

      if (
        !item ||
        item.quantity !== Number(button.dataset.quantity)
      ) {
        return (
          'Il carrello è cambiato. ' +
          'Controlla la riga prima di salvarla.'
        );
      }

      if (!simple(item) || item.instructions?.can_remove === false) {
        return 'Questo articolo non può essere salvato separatamente.';
      }

      try {
        upsert(lineRecord(item), true);
      } catch (error) {
        throw Error(
          'Salvataggio non riuscito: il prodotto resta nel carrello. ' +
          error.message
        );
      }

      try {
        await post('cart/change.js', {
          id: item.key,
          quantity: 0
        });
      } catch (_) {
        return (
          'Prodotto salvato. Non posso confermare la rimozione: ' +
          'verifica se è ancora nel carrello.'
        );
      }

      const fresh = await cart();

      return fresh.items.some(currentItem => currentItem.key === item.key)
        ? 'Prodotto salvato. Controlla la riga ancora presente nel carrello.'
        : 'Prodotto salvato per dopo su questo browser.';
    });
  }

  function saveSuggestion(button, scope) {
    const form = button.closest('form');
    const card = form.closest('article');
    const id = form.querySelector('[name="id"]')?.value;

    if (!/^\d+$/.test(String(id || ''))) return;

    const select = form.querySelector('select[name="id"]');
    const pill = form.querySelector('[aria-pressed="true"]');

    const record = {
      uid: String(id),
      variant: String(id),
      quantity: 1,
      title:
        card
          .querySelector('.crest-upsell__name,.routine-upsell__name')
          ?.textContent.trim() || 'Prodotto CREST',
      format:
        select?.selectedOptions[0]?.textContent.trim() ||
        pill?.textContent.trim() ||
        '',
      url: safeURL(card.querySelector('a')?.href),
      image: safeURL(card.querySelector('img')?.src, true)
    };

    try {
      const created = upsert(record, false);

      sync();

      notice(
        scope,
        created
          ? 'Abbinamento salvato per dopo, senza aggiungerlo al carrello.'
          : 'Questo formato è già tra i prodotti salvati.'
      );
    } catch (error) {
      notice(
        scope,
        'Non è stato possibile salvare il prodotto. ' + error.message
      );
    }
  }

  function restore(drawer, uid) {
    return drawerRun(drawer, async () => {
      const saved = readSaved().find(item => item.uid === uid);

      if (!saved) {
        return 'La lista dei salvati è già cambiata.';
      }

      const current = await cart();

      if (
        current.items.some(
          item =>
            simple(item) &&
            String(item.variant_id) === saved.variant
        )
      ) {
        return (
          'Il formato è già nel carrello. ' +
          'Puoi modificarne la quantità nella sua riga.'
        );
      }

      try {
        await post('cart/add.js', {
          items: [{
            id: saved.variant,
            quantity: saved.quantity
          }]
        });
      } catch (_) {
        return (
          'Verifica il carrello prima di riprovare: ' +
          'il prodotto potrebbe essere esaurito o la risposta ' +
          'potrebbe non essere arrivata. La selezione resta salvata.'
        );
      }

      try {
        drop(uid);
      } catch (_) {
        return (
          'Prodotto aggiunto. ' +
          'Non è stato possibile aggiornare la lista salvata.'
        );
      }

      return (
        'Prodotto aggiunto al carrello. ' +
        'Prezzo e disponibilità aggiornati.'
      );
    });
  }

customElements.define(
  'crest-shared-saved',
  class extends HTMLElement {
    connectedCallback() {
      queueMicrotask(() => {
        if (this.isConnected) this.mount();
      });
    }

    mount() {
      const scope = this.closest(
        'cart-drawer,crest-routine-page'
      );

      if (!scope) return;

      /*
       * Nel carrello vuoto il contenitore normale è nascosto.
       * Spostiamo i salvati nell'area vuota visibile, che include
       * anche la navigazione da tastiera del carrello laterale.
       */
      if (scope.matches('cart-drawer')) {
        const emptyArea = scope.querySelector(
          '.drawer__inner-empty'
        );

        if (emptyArea && this.parentElement !== emptyArea) {
          emptyArea.append(this);
          return;
        }
      }

      this.querySelectorAll(
        'template[data-crest-save-template]'
      ).forEach(template => {
        const input = Array.from(
          scope.querySelectorAll('[data-quantity-line-key]')
        ).find(
          input =>
            input.dataset.quantityLineKey === template.dataset.key
        );

        const row = input?.closest('.cart-item');

        const wrapper = row?.querySelector(
          '.cart-item__quantity-wrapper'
        );

        if (
          wrapper &&
          !wrapper.querySelector(
            '[data-routine-save],[data-crest-save-line]'
          )
        ) {
          wrapper.append(template.content.cloneNode(true));
        }
      });

      scope.querySelectorAll(
        'form.crest-upsell__form,form.routine-upsell__form'
      ).forEach(form => {
        if (form.querySelector('[data-crest-save-suggestion]')) {
          return;
        }

        const button = document.createElement('button');

        button.type = 'button';
        button.className = 'crest-saved-link';
        button.dataset.crestSaveSuggestion = '';
        button.textContent = 'Salva per dopo';

        form.append(button);
      });

      this.draw();
    }

    draw() {
      this.inert = Boolean(
        states.get(this.closest('cart-drawer'))
      );

      const section = this.querySelector(
        '[data-crest-saved-section]'
      );

      if (!section) return;

      const box = this.querySelector('[data-crest-saved-list]');
      const count = this.querySelector('[data-crest-saved-count]');

      /*
       * La sezione resta sempre presente,
       * indipendentemente dagli articoli nel carrello
       * e dal numero di prodotti salvati.
       */
      section.hidden = false;

      let list;

      try {
        list = readSaved();
      } catch (_) {
        count.textContent = '(—)';
        box.textContent =
          'Salvataggio non disponibile in questo browser.';
        return;
      }

      count.textContent = '(' + list.length + ')';

      if (list.length === 0) {
        box.innerHTML = `
          <p class="crest-saved-empty">
            Non hai ancora prodotti salvati.
            Usa “Salva per dopo” per ritrovarli qui.
          </p>
        `;
        return;
      }

      box.innerHTML = list.map(item => `
        <article class="crest-saved-card">
          ${
            item.image
              ? `
                <img
                  src="${escape(safeURL(item.image, true))}"
                  alt=""
                  width="55"
                  height="74"
                  loading="lazy"
                >
              `
              : ''
          }

          <div>
            <a href="${escape(safeURL(item.url) || '#')}">
              ${escape(item.title)}
            </a>

            <p>
              ${escape(item.format)} · ${item.quantity} pz
            </p>

            <small>
              Prezzo e disponibilità verificati all’aggiunta.
            </small>

            <div class="crest-saved-card__buttons">
              <button
                type="button"
                class="crest-saved-restore"
                data-crest-saved-restore="${escape(item.uid)}"
              >
                Sposta nel carrello
              </button>

              <button
                type="button"
                class="crest-saved-link"
                data-crest-saved-forget="${escape(item.uid)}"
              >
                Elimina dai salvati
              </button>
            </div>
          </div>
        </article>
      `).join('');
    }
  }
);

  document.addEventListener('click', event => {
    const button = event.target.closest('button');

    if (!button || button.disabled) return;

    const scope = button.closest('cart-drawer,crest-routine-page');

    if (!scope) return;

    if (button.hasAttribute('data-crest-save-line')) {
      saveLine(button, scope);
    }

    if (button.hasAttribute('data-crest-save-suggestion')) {
      saveSuggestion(button, scope);
    }

    if (
      button.dataset.crestSavedRestore &&
      scope.matches('cart-drawer')
    ) {
      restore(scope, button.dataset.crestSavedRestore);
    }

    if (button.dataset.crestSavedForget) {
      try {
        drop(button.dataset.crestSavedForget);
        sync();
      } catch (_) {
        notice(scope, 'Impossibile aggiornare la lista salvata.');
      }
    }
  });

  window.addEventListener('storage', event => {
    if (event.key === key) sync();
  });

 window.CrestSharedSaved = {
  sync,
  read: readSaved,
  save: upsert,
  remove: drop
};
})();